import { registerPlugin } from '@capacitor/core';
const CapgoLLM = registerPlugin('CapgoLLM', {
    web: () => import('./web').then((m) => new m.CapgoLLMWeb()),
});
export * from './definitions';
export { CapgoLLM };
//# sourceMappingURL=index.js.map